import iconCommentActive from '../img/icon-comment-active.svg';
import iconCommentActiveBlue from '../img/icon-comment-active-blue.svg';
import iconCommentActiveGreen from '../img/icon-comment-active-green.svg';
import iconCommentActiveYellow from '../img/icon-comment-active-yellow.svg';
import iconCommentInactive from '../img/icon-comment-none.svg';

export const getFeedbackIcon = (color = '') => {
  switch (color) {
    case 'none':
      return iconCommentInactive;
    case 'blue':
      return iconCommentActiveBlue;
    case 'green':
      return iconCommentActiveGreen;
    case 'yellow':
      return iconCommentActiveYellow;
    default:
      return iconCommentActive;
  }
};
